// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'bug';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M12.938 5.625a3.937 3.937 0 1 0-7.876 0v.563h7.875z' />
    <path d='M5.063 13.5a3.937 3.937 0 1 0 7.875 0V6.187H5.061zm7.383-9.78a3.375 3.375 0 0 0 2.18-3.157M5.554 3.72A3.375 3.375 0 0 1 3.376.562m9.562 9.001h4.5' />
    <path d='M17.438 14.063a4.5 4.5 0 1 1 0-9m-12.375 4.5h-4.5m0 4.5a4.5 4.5 0 1 0 0-9' />
  </g>
);

export const viewBox = '0 0 18 18';
